import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { Box } from 'foundations-components/transitional/components/Box';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WizardProgressSection = ({
  noteMessage,
  noteOptions,
  onProgressStepClick,
  linkMessageLine1,
  linkMessageLine2,
  link
}) => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(Box, {
    paddingBlock: "200",
    textAlign: "center",
    children: /*#__PURE__*/_jsxs(Clickable, {
      id: "clickable",
      onClick: isMobile ? onProgressStepClick : () => {},
      children: [/*#__PURE__*/_jsx(Text, {
        color: "text-core-default",
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: noteMessage,
          options: noteOptions
        })
      }), /*#__PURE__*/_jsx(View, {
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsxs(RouterLink, {
          onClick: onProgressStepClick,
          to: link,
          use: "on-bright",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: linkMessageLine1
          }), linkMessageLine2 && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
              message: linkMessageLine2
            })]
          })]
        })
      })]
    })
  });
};
export default WizardProgressSection;